<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Reallocate Shipment</strong>           
          </div>
          <div class="box" id="addform">
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-row>
                <b-col md="4">
                  <b-form-group label="Delivery Agent"  :label-cols="4" >
                    <!-- <b-form-select v-model="customer"
                     name="deliveryagentname" @change="focusInput()" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-1.deliveryagentname') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="customer" v-for="customer in data1" :key="customer.deliveryagentmasterid" :disabled="customer.capacityforallocation== 0">{{ customer.deliveryagentfirstname | capitalize }} {{ customer.deliveryagentlastname | capitalize }} - {{ customer.deliveryagentmobilenumber}}</option>
                    </b-form-select>  -->
                    <v-select  
                    v-model="customer.deliveryagentmasterid" :options="data1" placeholder="Select Delivery Agent"  @change="focusInput()" @input="selectdeliveryagent(customer)"  name="deliveryagentname" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-1.deliveryagentname') }">
                    </v-select>
                    <span style="width: 270px;" v-show="errors.has('form-1.deliveryagentname')" class="help text-danger">{{ errors.first('form-1.deliveryagentname') }}</span>
                  </b-form-group>
                </b-col>


              <b-col md="4">
               <b-form-group label="Shipping Id"  :label-cols="4" >
                 
                <vue-tags-input
                v-model="customer.shippingid" 
                :tags="tags"
                 @tags-changed="newTags => tags = newTags  "
                  :avoidAddingDuplicates="avoidAddingDuplicates"
                 :placeholder="placeholder"
                  ref="taginput"
                 v-bind:separators="[',', ';']"
                   />
                   <span class="badge badge-success1">&nbsp;</span>&nbsp;
                   <label :label-cols="4" >Unique Shipping Id</label><br>
                   <span class="badge badge-success2">&nbsp;</span>&nbsp;&nbsp;<label :label-cols="4" >Repeat/Duplicate Shipping Id </label>
                    <span v-show="errors.has('form-1.shipmentid')" class="help text-danger">{{ errors.first('form-1.shipmentid') }}</span>
                  </b-form-group> 
              </b-col>
                
                <b-col md="4">
                 <b-button  :disabled="disabled == 0" class="mr-4" type="submit" size="md" variant="primary">Reallocate</b-button>
                 <b-button :disabled="disabled == 0" @click="clear" size="md" variant="danger">Clear</b-button>
                </b-col>
              </b-row>
           
            </form>
          </div>
            <div slot="footer" v-if="this.invalidshipppingid"  >
              <b-row>
                <b-col md="12">
                <span>
                  <h6>Invalid Shipmemnts : <strong> {{invalidshipppingid}}</strong></h6> 
                </span>
                </b-col> 
              </b-row>
                
             
               
                      
          </div>
          
          <b-modal v-if="this.tags.length > 0" title="Confirmation Box" v-model="toggleInfo" size="sm" @ok="toggleInfoModal = false">
            <template slot="modal-header" slot-scope="{ close }">
            <h5>Reallocate Shipment</h5>
            </template>
            <template slot="default" slot-scope="{ hide }">
              <form v-on:submit.prevent="toggleInfoModal(value)">
                <div class="modal-background"></div>
                <div class="modal-card">
                  <section class="modal-card-body">                          
                    <span> Are you sure to reallocate shipment ?</span>
                  </section>
                  <footer slot="modal-footer">
                    <b-button variant="primary" size="sm" type="submit">Ok</b-button>
                  </footer>
                </div>
              </form>
            </template>
            <footer slot="modal-footer" slot-scope="{ cancel }">
              <b-button size="sm" variant="danger" @click="closemodal">
                Cancel
              </b-button>
            </footer>
          </b-modal>
        </b-card>  
      </b-col>   
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import VueTagsInput from '@johmun/vue-tags-input';
export default {
  components: {
    VueTagsInput,
  },
  data: function() {
    return {
      name: 'allocation',
      data: [],
      DAPendingStatus: [],
      customer: {},
      toggleInfo: false,
      avoidAddingDuplicates:false,
      placeholder:"Add shippingid",
      data1:'',
      selected:'',
      shippingid: '',
      invalidshipppingid:'',
      tags: [],
      disabled: '',
      selectedusertype:0,
      value:'',
      }
  },
  created: function() {
    this.displaydata()
  },
  computed: {
  serveur() { 
    // alert('ss');
    return this.customer.deliveryagentmasterid.key; },
  code() { 
    // alert('cc');
    return this.customer.usertype; }
},
  methods: {
    validateForm(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.toggleInfo = !this.toggleInfo
        }
      })
    },
    selectdeliveryagent(value_vehicle) {
        if(value_vehicle==null){
          this.customer.deliveryagentmasterid = '';
          this.displaydata();
        }
         console.log("value_vehicle : ",value_vehicle);
    },
    focusInput() 
    {
      // alert(usertype);
      // this.selectedusertype=usertype;
        this.$refs.taginput.$refs.newTagInput.focus()
        this.disabled=1;
    },
    
   toggleInfoModal: function () {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
       var shipmentid=[];
       for(var i = 0; i < this.tags.length; i++) {
          shipmentid.push(this.tags[i].text);  
       }
      const shipmentobj={
        deliveryagentmasterid: `${this.customer.deliveryagentmasterid.key}`,
        shippingid:shipmentid,
        lastmodifiedby: `${userInfo.sysemailid}`,
        shippincode:`${userInfo.pickuplocationpincode}`,
        mobilenumber:`${userInfo.usermobilenumber}`,
        hub_id:`${userInfo.pickuplocationmasterid}`,
        // usertype:this.selectedusertype,
      }
      this.$http.post(`${CONSTANTS.API_URL}/ConsignmentMaster.svc/ConsignmentMasterReallocation`, shipmentobj)
        .then((result) => {
            console.log("result",result);
          if (result.body.returnmsg.toLowerCase() === 'successful') {
            
          
            this.invalidshipppingid=result.body.invalid_shipment;
             //console.log(invalidshipppingid.invalid_shipment);

            if (result.body.returnvalue >0 ) {
               Utils.notify('Shipment reallcation successfully'), 
                // this.$fire({
                //   text: "Shipment Reallocation Successfully",
                //   type: "success",
                //   timer: 30000
                // });

               this.customer = {}
               this.tags=[];
              
  
             this.errors.clear('form-1')
            }else{
             
            // Utils.notify('invalid shipment id', 'error')
             this.$fire({
                  text: result.body.returnvalue,
                  type: "error",
                  timer: 30000
                });

            }
            this.$router.push('/reallocationpickup');
             

           // this.displaydata();
          } else {
            this.$fire({
                  text: result.body.returnvalue,
                  type: "error",
                  timer: 30000
                });
            // Utils.notify(' All  shipment Are Invalid','error')
            this.invalidshipppingid=result.body.invalid_shipment;
            this.tags=[];

          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
      this.toggleInfo = !this.toggleInfo
    },
    closemodal: function () {
      // console.log('closemodal')
      this.toggleInfo = !this.toggleInfo
    },
    clear: function () {
      this.tags=[];
      this.customer = {}
      this.invalidshipppingid="";
      this.errors.clear('form-1')
    },
     GetSortOrder : function(prop) {
        return function(a, b) {
            if (a[prop] > b[prop]) {
                return 1;
            } else if (a[prop] < b[prop]) {
                return -1;
            }
            return 0;
        }

    },


    // displaydata: function() {
    //   var userdata = localStorage.getItem('userData')
    //   var userInfo = JSON.parse(userdata)
    //   const customerGetobj = {
    //     deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
    //     isactive: '1'
    //   }
    //   this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, customerGetobj)
    //     .then((result) => {
    //       this.data1 = result.body
    //       this.data1.sort(this.GetSortOrder('deliveryagentfirstname'))
    //     })
    //     .catch((ex) => {
    //       console.log('error', ex)
    //     })
    // },
    displaydata: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
    
      //console.log("hello"+userInfo.sysusermasterid);
      // || userInfo.sysusermasterid==39
     if(userInfo.sysusermasterid==25 )
     {
     
      let customerGetobj = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1',
        usertype:'4',

      }
 this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, customerGetobj)
        .then((result) => {
          this.data1 = result.body;
          var data = [];
 
          result.body.forEach(function (srData) {
            data.push({
              key:srData.deliveryagentmasterid,
              label:srData.deliveryagentmasterid+ ' - '+srData.deliveryagentfirstname+ ' - '+srData.deliveryagentlastname
            });
          });
          this.data1 = data;
          // this.data1.sort(this.GetSortOrder('deliveryagentfirstname'))
        })
        .catch((ex) => {
          console.log('error', ex)
        })
     }
   
     else
     {
      let customerGetobj = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1'

      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, customerGetobj)
        .then((result) => {
          this.data1 = result.body;
          var data = [];
 
          result.body.forEach(function (srData) {
            data.push({
              key:srData.deliveryagentmasterid,
              label:srData.deliveryagentmasterid+ ' - '+srData.deliveryagentfirstname+ ' - '+srData.deliveryagentlastname
            });
          });
          this.data1 = data;
          // this.data1.sort(this.GetSortOrder('deliveryagentfirstname'))
        })
        .catch((ex) => {
          console.log('error', ex)
        })
      
    }
 
      
    },
  },
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }
};
</script>
<style >
  .badge-success1
  {
  background-color: #5C6BC0;
    color: #fff;
  }
.badge-success2
  {
  background-color:  #e54d42;
    color: #fff;
  }


</style>

